<div *ngFor="let mensagem of mensagens; let indice = index" class="toastr" >
  <prv-toastr #toastr 
    [mensagem]="mensagem.mensagem" 
    [tipoToastr]="mensagem.tipoMensagem" 
    (exibeToastrChange)="fecharToastr(indice)">
  </prv-toastr>
</div>